import {
  COLLECTION_MASTERY_TREATMENT,
  FEATURE_FLAGS,
  useConfig,
} from '@/core/feature-flags'
import { useActivePlan } from '@/features/plan/hooks/use-active-plan'
import { showsCollectionTab } from '@/shared/lib/collection-tab'

/**
 * Whether the Collection takes Discover's tab slot for this person.
 *
 * One place decides, because three asked separately would eventually disagree — and a nav that
 * says one thing while the page it opens says another is worse than either answer.
 *
 * An unresolved config reads as not-in-arm. The config is prefetched app-wide and held forever, so
 * this is rarely seen; when it is, keeping Discover is the safe way to be briefly wrong, since the
 * alternative shows the treatment to someone who may be control.
 */
export function useShowsCollection(): boolean {
  const { activePlan } = useActivePlan()
  const { data } = useConfig()
  const arm = data?.config?.[FEATURE_FLAGS.COLLECTION_MASTERY_ARM]
  return showsCollectionTab(
    activePlan?.hasCollection === true,
    arm === COLLECTION_MASTERY_TREATMENT,
  )
}
